import React from "react";
import Loading from './Loading';
import CredentialTable from "./CredentialTable";
import useCredentialData from "../hooks/useCredentialData";
import { FormattedMessage } from 'react-intl';

function CredentialBlock({ workspace }) {
  const { error, isLoaded, oAuthCredentials } = useCredentialData(workspace);

  if (error) {
    return <div><FormattedMessage id="applications.error"/></div>
  } 
  else if (!isLoaded) {
    return <Loading />
  } 
  else {
    return <CredentialTable credentialData={oAuthCredentials} workspace={workspace}/>
  }
}

export default CredentialBlock;